// extracted by mini-css-extract-plugin
module.exports = {"reportingVerticalBarChart":"verticalBarChart_reportingVerticalBarChart__yT-YC","chartWrapper":"verticalBarChart_chartWrapper__18Mit"};